import React from 'react';

var FeatureFlagsContext = React.createContext({
  featureFlags: {}
});

var useFeatureFlag = (flagName => {
  const {
    featureFlags
  } = React.useContext(FeatureFlagsContext);
  return featureFlags[flagName] === "on";
});

var setFlagCookie = ((name, cookieValue = 'on', {
  domain
}) => {
  document.cookie = `${name}=${cookieValue};max-age=${60 * 60 * 24 * 365}${domain}`;
});

const FeatureFlagsContextProvider = ({
  children,
  featureFlags,
  cookieDomain
}) => {
  const [currentFeatureFlags, setFeatureFlags] = React.useState(featureFlags);
  /*
  // setFlag is not exposed via the context as the application should not be able to set flags
  // it is exposed via window so that developers etc. can alter featureflags at run time via console or other tools
  */

  const setFlag = (flag, flagValue = 'on') => {
    setFeatureFlags(current => ({ ...current,
      [flag]: flagValue
    }));
    setFlagCookie(flag, flagValue, {
      domain: cookieDomain
    });
  };

  const featureFlagTools = {
    setFlag,
    getFlags: () => currentFeatureFlags
  };
  React.useEffect(() => {
    window.acurisDevTools = window.acurisDevTools || {};
    window.acurisDevTools.featureFlags = featureFlagTools;
    return () => {
      delete window.acurisDevTools.featureFlags;
    };
  }, [currentFeatureFlags]);
  const value = {
    featureFlags: currentFeatureFlags
  };
  return /*#__PURE__*/React.createElement(FeatureFlagsContext.Provider, {
    value: value
  }, children);
};

export { FeatureFlagsContext, FeatureFlagsContextProvider, useFeatureFlag };
//# sourceMappingURL=index.js.map
